import { Reducer } from "@reduxjs/toolkit"
import { solicitacaoDetalhadaVazia } from "model/solicitacao/SolicitacaoDetalhada"
import { OperacaoFormularioCRUD } from "service/restricao/OperacaoFormulario/OperacaoFormulario"
import { EstadoRequisicao } from "store/types"
import { ResponseError } from "view/component/MensagensErroServidor/ErroServidor.utils"
import { SolicitacaoCorrenteAction } from "./SolicitacaoCorrente.action"
import { SolicitacaoCorrenteAcao, SolicitacaoCorrenteActionTypes, SolicitacaoCorrenteState } from "./SolicitacaoCorrente.types"


const estadoInicial: SolicitacaoCorrenteState = {
  operacao: OperacaoFormularioCRUD.Visualizar,
  estado: EstadoRequisicao.OCIOSO,
  acao: SolicitacaoCorrenteAcao.Visualizar,

  erros: undefined,

  solicitacao: solicitacaoDetalhadaVazia(),
  anexos: {
    elementos: [],
    estado: EstadoRequisicao.OCIOSO,
  },
}


export const solicitacaoCorrenteReducer: Reducer<SolicitacaoCorrenteState, SolicitacaoCorrenteActionTypes> = (state = estadoInicial, action): SolicitacaoCorrenteState => {
  // Visualização
  if (SolicitacaoCorrenteAction.visualizacao.carregar.pending.match(action)) {
    const previewSolicitacao = action.meta.arg.solicitacao ?? state.solicitacao
    return {
      ...state,

      estado: EstadoRequisicao.CARREGANDO,
      operacao: OperacaoFormularioCRUD.Visualizar,
      acao: SolicitacaoCorrenteAcao.Visualizar,

      erros: undefined,

      solicitacao: previewSolicitacao,
      anexos: {
        estado: EstadoRequisicao.OCIOSO,
        elementos: []
      }
    }

  } else if (SolicitacaoCorrenteAction.visualizacao.carregar.fulfilled.match(action)) {
    return {
      ...state,

      estado: EstadoRequisicao.BEM_SUCEDIDO,
      operacao: OperacaoFormularioCRUD.Visualizar,
      erros: undefined,

      solicitacao: action.payload ?? state.solicitacao,
    }

  } else if (SolicitacaoCorrenteAction.visualizacao.carregar.rejected.match(action)) {
    return {
      ...state,

      estado: EstadoRequisicao.FALHOU,
      operacao: OperacaoFormularioCRUD.Visualizar,
      erros: action.payload as ResponseError,
    }

  // Edição
  } else if (SolicitacaoCorrenteAction.edicao.iniciar.match(action)) {
    return {
      ...state,
      erros: undefined,
      operacao: OperacaoFormularioCRUD.Atualizar,
      acao: SolicitacaoCorrenteAcao.Atualizar,
    }

  } else if (SolicitacaoCorrenteAction.edicao.cancelar.match(action)) {
    return {
      ...state,
      erros: undefined,
      operacao: OperacaoFormularioCRUD.Visualizar,
      acao: SolicitacaoCorrenteAcao.Visualizar,
    }

  } else if (SolicitacaoCorrenteAction.edicao._realizarEdicao.pending.match(action)) {
    return {
      ...state,

      estado: EstadoRequisicao.CARREGANDO,
      // Não definir, pois pode ser via botão de alteração de situação
      // como também via formulário de edição
      // operacao:
      // O formulário deve continuar com a operação que estava
      // mas a ação muda para atualizar
      acao: SolicitacaoCorrenteAcao.Atualizar,
      erros: undefined
    }
  } else if (SolicitacaoCorrenteAction.edicao._realizarEdicao.fulfilled.match(action)) {
    return {
      ...state,

      estado: EstadoRequisicao.BEM_SUCEDIDO,
      // Toda alteração resulta em visualização
      operacao: OperacaoFormularioCRUD.Visualizar,
      acao: SolicitacaoCorrenteAcao.Visualizar,
      solicitacao: action.payload,
      erros: undefined
    }
  } else if (SolicitacaoCorrenteAction.edicao._realizarEdicao.rejected.match(action)) {
    return {
      ...state,

      estado: EstadoRequisicao.FALHOU,
      // Não definir, pois pode ser via botão de alteração de situação
      // como também via formulário de edição
      // operacao:
      erros: action.payload as ResponseError,
    }
  // Criação
  } else if (SolicitacaoCorrenteAction.criacao.iniciar.match(action)) {
    return {
      ...state,

      solicitacao: solicitacaoDetalhadaVazia(),
      estado: EstadoRequisicao.OCIOSO,
      erros: undefined,
      operacao: OperacaoFormularioCRUD.Criar,
      anexos: {
        estado: EstadoRequisicao.OCIOSO,
        elementos: []
      },
    }
  } else if (SolicitacaoCorrenteAction.criacao.persistir.pending.match(action)) {
    return {
      ...state,
      estado: EstadoRequisicao.CARREGANDO,
      erros: undefined,
    }
  } else if (SolicitacaoCorrenteAction.criacao.persistir.fulfilled.match(action)) {
    return {
      ...state,
      
      operacao: OperacaoFormularioCRUD.Visualizar,
      acao: SolicitacaoCorrenteAcao.Visualizar,
      
      estado: EstadoRequisicao.BEM_SUCEDIDO,
      erros: undefined,
      
      solicitacao: action.payload
    }
  } else if (SolicitacaoCorrenteAction.criacao.persistir.rejected.match(action)) {
    return {
      ...state,
      
      estado: EstadoRequisicao.FALHOU,
      erros: action.payload as ResponseError,
    }
  // Anexos
  } else if (SolicitacaoCorrenteAction.anexos.adicionarNaLista.match(action)) {
    return {
      ...state,

      anexos: {
        ...state.anexos,
        elementos: [
          ...action.payload.anexos,
          ...state.anexos.elementos,
        ]
      }
    }
  } else if (SolicitacaoCorrenteAction.anexos.carregar.pending.match(action)) {
    return {
      ...state,

      anexos: {
        estado: EstadoRequisicao.CARREGANDO,
        elementos: []
      }
    }
  } else if (SolicitacaoCorrenteAction.anexos.carregar.fulfilled.match(action)) {
    return {
      ...state,

      anexos: {
        estado: EstadoRequisicao.BEM_SUCEDIDO,
        elementos: action.payload
      }
    }
  } else if (SolicitacaoCorrenteAction.anexos.carregar.rejected.match(action)) {
    return {
      ...state,

      anexos: {
        ...state.anexos,
        estado: EstadoRequisicao.FALHOU
      }
    }
  }else if (SolicitacaoCorrenteAction.visualizacao.atualizar.match(action)) {
    return {
      ...state,
      solicitacao: action.payload
    }
  
  }


  return state
}
